import style from './SocialNetworks.module.css'
import icons from '../../../../img/icons/icons';
import { ButtonActionMini } from '../../buttons/actionMini/ButtonActionMini';

export const SocialNetworks = () => {
    const redirectToWhatsApp = () => {
        window.location.href = 'https://wa.me/555584544008';
      };
    
      const redirectToFacebook = () => {
        window.location.href = 'https://www.facebook.com/newzapecursos';
      };
    
      const redirectToInstagram = () => {
        window.location.href = 'https://www.instagram.com/newzape_cursos/';
      };
    
      const redirectToYouTube = () => {
        window.location.href = 'https://www.youtube.com';
      };
    return (
        <div className={style.Content}>
            <ButtonActionMini
                icon={icons.WhatsApp}
                click={redirectToWhatsApp}
            />
            <ButtonActionMini
                icon={icons.Facebook}
                click={redirectToFacebook}
            />
            <ButtonActionMini
                icon={icons.Instagram}
                click={redirectToInstagram}
            />
        </div>
    );
}